 export const makeSendActivationEmailDTO = (domainName) => ({
    domainName
  });
